module.exports = __webpack_public_path__ + "icon-trash-lake.0529e517c6c3459d25c2.svg";